import React, { useState, useEffect } from 'react';
import { API_BASE_URL } from "../../global";
import axios from "axios";
import { toast } from "react-toastify";

const AddionalAgentcompoent = ({ isaddionalagentModalOpen, closeaddionalagentModal, selectedFile, handleContinueClick, fetchAllCases }) => {



    const [ogAgentlist, setogAgentlist] = useState([]);
    const [agentlist, setagentlist] = useState([]);
    const [selecteditem, setSelecteditem] = useState(null);
    const [loading, setLoading] = useState(true);

    const [agentPrompts, setAgentPrompts] = useState({});
    const [selectedPromptAgent, setSelectedPromptAgent] = useState("");
    const [currentPrompt, setCurrentPrompt] = useState("");
    const [editPromptInfo, setEditPromptInfo] = useState({ agentId: null, index: null });
    const [showPromptSection, setShowPromptSection] = useState(false);


    const handleClose = () => {
        closeaddionalagentModal();
    };

    // const handleSubmit = () => {
    //     alert("Agents submitted successfully!");
    //     closeaddionalagentModal();
    // };
    const handleSubmit = async () => {
        try {

            const selectedAgents = agentlist.filter(a => a.agentIsSelected === 1);
            const originalAgents = ogAgentlist.filter(a => a.agentIsSelected === 1);
            const newAgents = selectedAgents.filter(
                sa => !originalAgents.some(og => og.agentSummaryId === sa.agentSummaryId)
            );

            const userPromptArray = [];

            Object.entries(agentPrompts).forEach(([agentId, prompts]) => {
                prompts.forEach((prompt) => {
                    userPromptArray.push({
                        userPromptDescription: prompt,
                        userPromptAgentId: parseInt(agentId, 10),
                    });
                });
            });

            const payload = {
                case_id: selectedFile?.caseId,
                service_id: selectedFile?.caseServiceId,
                summary_agents: selectedAgents.map(a => a.agentSummaryId),
                mode: "AddAgents",
                userPrompt: JSON.stringify(userPromptArray)
            };



            const response = await axios.post(`${API_BASE_URL}services`, payload);

            if (response.data.status === 1) {
                toast.success("Agents submitted successfully!");
                closeaddionalagentModal();
                fetchAllCases();
            } else {
                toast.error(response.data?.message);
            }
        } catch (err) {
            console.error("Error submitting agents:", err);
            toast.error("Error submitting agents:");
        }
    };


    const fetchDetails = async () => {
        setLoading(true);
        try {
            const response = await axios.post(`${API_BASE_URL}services`, {
                case_id: selectedFile?.caseId,
                service_id: selectedFile?.caseServiceId,
                mode: "AgentSummary",
            });


            if (response.data.status === 1) {
                const agentlist = response.data.message;
                setagentlist(agentlist);
                setogAgentlist(agentlist);
            } else {
                setagentlist([]);
                setogAgentlist([]);
            }
        } catch (err) {
            console.error("Error fetching item details:", err);
            setagentlist([]);
            setogAgentlist([]);
        } finally {
            setLoading(false);
        }
    };

    // Toggle agent selection
    const handleAgentToggle = (agentId) => {
        setSelectedPromptAgent("");

        setagentlist((prev) =>
            prev.map((agent) =>
                agent.agentSummaryId === agentId
                    ? { ...agent, agentIsSelected: agent.agentIsSelected === 1 ? 0 : 1 }
                    : agent
            )
        );

        setAgentPrompts((prev) => {
            const updated = { ...prev };
            const toggledAgent = agentlist.find((a) => a.agentSummaryId === agentId);

            if (toggledAgent && toggledAgent.agentIsSelected === 1) {
                delete updated[agentId];
            }

            return updated;
        });

    };
    useEffect(() => {
        if (selectedFile) {
            setSelecteditem(selectedFile);
            fetchDetails();
        }
    }, [selectedFile, isaddionalagentModalOpen]);


    // Agents selected now but not originally selected
    const newAgentsSelected = agentlist.some((a) => {
        const isNowSelected = a.agentIsSelected === 1;
        const wasOriginallySelected = ogAgentlist.some(
            (og) => og.agentSummaryId === a.agentSummaryId && og.agentIsSelected === 1
        );
        return isNowSelected && !wasOriginallySelected;
    });

    // Agents eligible for prompts (selected + summaryUserPromptEnable)
    // const eligibleAgents = agentlist.filter(
    //     (a) => a.agentIsSelected === 1  && a.summaryUserPromptEnable === 1
    // );
    const eligibleAgents = agentlist.filter((a) => {
        const isNowSelected = a.agentIsSelected === 1;
        const wasOriginallySelected = ogAgentlist.some(
            (og) => og.agentSummaryId === a.agentSummaryId && og.agentIsSelected === 1
        );
        return isNowSelected && !wasOriginallySelected && a.summaryUserPromptEnable === 1;
    });


    return (
        <>
            {isaddionalagentModalOpen && (
                <div className="modal spl-modal fade show supplement-page" style={{ display: 'block', zIndex: 999 }} tabIndex="-1" aria-labelledby="uploadModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                        <div className="modal-content">

                            {/* Header */}
                            <div className="modal-header">
                                <h5 className="modal-title" id="uploadModalLabel">Select Additional Summary Agents</h5>
                                <button type="button" className="btn-close" onClick={handleClose} style={{ fontSize: 'large' }}>
                                    <svg width={18} height={18} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
                                        <path d="M183.1 137.4C170.6 124.9 150.3 124.9 137.8 137.4C125.3 149.9 125.3 170.2 137.8 182.7L275.2 320L137.9 457.4C125.4 469.9 125.4 490.2 137.9 502.7C150.4 515.2 170.7 515.2 183.2 502.7L320.5 365.3L457.9 502.6C470.4 515.1 490.7 515.1 503.2 502.6C515.7 490.1 515.7 469.8 503.2 457.3L365.8 320L503.1 182.6C515.6 170.1 515.6 149.8 503.1 137.3C490.6 124.8 470.3 124.8 457.8 137.3L320.5 274.7L183.1 137.4z" />
                                    </svg>
                                </button>
                            </div>

                            {/* Body */}
                            <div className="modal-body" style={{ minHeight: 'auto' }}>
                                {loading ? (
                                    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                ) : (
                                    <>
                                        <div className="d-flex justify-content-start gap-1">
                                            <div className="job-selection w-100">
                                                <div className="mb-0 w-100">
                                                    <div className='additional-agents-inner'
                                                        style={{
                                                            display: 'grid',
                                                            gridTemplateColumns: 'repeat(auto-fit, minmax(175px, 175px))',
                                                            rowGap: '20px',
                                                            width: '100%',
                                                            justifyContent: "start",
                                                        }}
                                                    >
                                                        {agentlist?.map((item) => {
                                                            const isSelected = item.agentIsSelected === 1;
                                                            const isOriginal = ogAgentlist.some(
                                                                (og) => og.agentSummaryId === item.agentSummaryId && og.agentIsSelected === 1
                                                            );


                                                            return (
                                                                <a
                                                                    className={`avatar-items ${isSelected ? 'active position-relative' : 'position-relative'}`}
                                                                    key={`summary${item.agentSummaryId}`}
                                                                    style={{
                                                                        width: '90%',
                                                                        padding: '10px 24px 10px 10px',
                                                                        cursor: 'pointer',
                                                                        position: 'relative',
                                                                        // border: isSelected ? "1px solid #007bff" : "1px solid #ddd",
                                                                        borderRadius: "8px",
                                                                        backgroundColor: isSelected ? "#f0f8ff" : "#fff",
                                                                        opacity: isOriginal ? 0.4 : 1,
                                                                        pointerEvents: isOriginal ? 'none' : 'auto',
                                                                        cursor: isOriginal ? "not-allowed" : "pointer",
                                                                    }}
                                                                    onClick={() => !isOriginal && handleAgentToggle(item.agentSummaryId)}
                                                                >
                                                                    {/* Tick */}
                                                                    {isSelected && (
                                                                        <span
                                                                            style={{
                                                                                position: 'absolute',
                                                                                top: '5px',
                                                                                right: '5px',
                                                                                background: '#000',
                                                                                color: '#fff',
                                                                                borderRadius: '50%',
                                                                                width: '20px',
                                                                                height: '20px',
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                justifyContent: 'center',
                                                                                fontSize: '12px'
                                                                            }}
                                                                        >
                                                                            <i className="fa-solid fa-check"></i>
                                                                        </span>
                                                                    )}

                                                                    {/* Content */}
                                                                    <div className="text-center d-flex align-items-start">
                                                                        <div>
                                                                            <span
                                                                                className="custom-icon-doc me-1"
                                                                                dangerouslySetInnerHTML={{ __html: item?.summaryPmtIcon }}
                                                                            ></span>
                                                                        </div>
                                                                        <div className="d-flex flex-column text-left align-items-start agents-info text-black">
                                                                            <p className="text-start my-0">{item.summaryPmtLabel}</p>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {showPromptSection && eligibleAgents.length > 0 && (
                                            <div className="mt-3 ms-1">

                                                {/* Saved prompts display */}
                                                {Object.entries(agentPrompts).map(([agentId, prompts]) => {
                                                    const agent = agentlist.find(
                                                        (a) => a.agentSummaryId.toString() === agentId
                                                    );
                                                    return (
                                                        <div
                                                            key={agentId}
                                                            className="mb-3 p-2 border rounded bg-light d-flex flex-column"
                                                        >
                                                            <p className="mb-2 fw-semibold">
                                                                {agent?.summaryPmtLabel}Instruction
                                                            </p>
                                                            {prompts.map((prompt, index) => (
                                                                <div
                                                                    key={index}
                                                                    className="d-flex justify-content-between align-items-start mb-1"
                                                                >
                                                                    <textarea
                                                                        className="form-control me-2"
                                                                        rows={2}
                                                                        value={prompt}
                                                                        readOnly={
                                                                            !(
                                                                                editPromptInfo.agentId === agentId &&
                                                                                editPromptInfo.index === index
                                                                            )
                                                                        }
                                                                        onChange={(e) =>
                                                                            setAgentPrompts((prev) => {
                                                                                const updated = { ...prev };
                                                                                updated[agentId][index] = e.target.value;
                                                                                return updated;
                                                                            })
                                                                        }
                                                                    />
                                                                    <div className="d-flex flex-column">
                                                                        {editPromptInfo.agentId === agentId &&
                                                                            editPromptInfo.index === index ? (
                                                                            <i
                                                                                className="fas fa-save text-success mb-2"
                                                                                style={{ cursor: "pointer", fontSize: "1.2rem" }}
                                                                                title="Save"
                                                                                onClick={() =>
                                                                                    setEditPromptInfo({ agentId: null, index: null })
                                                                                }
                                                                            />
                                                                        ) : (
                                                                            <i
                                                                                className="fas fa-edit text-warning mb-2"
                                                                                style={{ cursor: "pointer", fontSize: "1.2rem" }}
                                                                                title="Edit"
                                                                                onClick={() =>
                                                                                    setEditPromptInfo({ agentId, index })
                                                                                }
                                                                            />
                                                                        )}
                                                                        <i
                                                                            className="fas fa-trash text-danger"
                                                                            style={{ cursor: "pointer", fontSize: "1.2rem" }}
                                                                            title="Delete"
                                                                            onClick={() =>
                                                                                setAgentPrompts((prev) => {
                                                                                    const updated = { ...prev };
                                                                                    if (updated[agentId].length === 1) {
                                                                                        delete updated[agentId];
                                                                                    } else {
                                                                                        updated[agentId].splice(index, 1);
                                                                                    }
                                                                                    return updated;
                                                                                })
                                                                            }
                                                                        />
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    );
                                                })}

                                                {/* Add new prompt */}
                                                {showPromptSection && eligibleAgents.filter((a) => !agentPrompts[a.agentSummaryId]).length > 0 && (
                                                    <>
                                                       <h6>Instruct AI Agents</h6>

                                                        <select
                                                            className="form-select mb-2"
                                                            value={selectedPromptAgent}
                                                            onChange={(e) => setSelectedPromptAgent(e.target.value)}
                                                        >
                                                            <option value="">Select Agent</option>
                                                            {eligibleAgents
                                                                .filter((a) => !agentPrompts[a.agentSummaryId])
                                                                .map((agent) => (
                                                                    <option
                                                                        key={agent.agentSummaryId}
                                                                        value={agent.agentSummaryId}
                                                                    >
                                                                        {agent.summaryPmtLabel}
                                                                    </option>
                                                                ))}
                                                        </select></>)}

                                                {selectedPromptAgent && (
                                                    <div className='text-center'>
                                                        <textarea
                                                            className="form-control"
                                                            rows={3}
                                                            placeholder="Instruct AI agent..."
                                                            value={currentPrompt}
                                                            onChange={(e) => setCurrentPrompt(e.target.value)}
                                                        ></textarea>


                                                        <button
                                                            className="btn btn-secondary mt-2 me-2"
                                                            onClick={() => {
                                                                setCurrentPrompt("");
                                                                setSelectedPromptAgent("");
                                                            }}
                                                        >
                                                            Cancel
                                                        </button>
                                                        <button
                                                            className="btn btn-primary mt-2 "
                                                            onClick={() => {
                                                                if (!currentPrompt.trim()) return;
                                                                setAgentPrompts((prev) => ({
                                                                    ...prev,
                                                                    [selectedPromptAgent]: [currentPrompt],
                                                                }));
                                                                setCurrentPrompt("");
                                                                setSelectedPromptAgent("");
                                                            }}
                                                        >
                                                            Save
                                                        </button>


                                                    </div>
                                                )}
                                            </div>

                                        )}
                                        {newAgentsSelected && (
                                            <div className="d-flex justify-content-end mt-3 gap-1">
                                                {eligibleAgents.filter((a) => !agentPrompts[a.agentSummaryId]).length > 0 && !showPromptSection && (
                                                    <button
                                                        className="btn h-100 custom-file-button btn-outline-primary mb-2"
                                                        onClick={() => setShowPromptSection(true)}
                                                    >
                                                        Instruct AI Agents
                                                    </button>
                                                )}

                                                <button
                                                    className="btn common-btn d-flex justify-content-center align-items-center h-100 custom-file-button"
                                                    onClick={handleSubmit}
                                                >
                                                    <h4 className="mb-0 me-0 fs-5 fw-normal">
                                                        Submit <i className="fa-solid fa-arrow-right ms-1"></i>
                                                    </h4>
                                                </button>
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default AddionalAgentcompoent;
